/**
 * Translate the history entries onto the riskProfile for convenience.
 */
export function buildHistory(riskProfile, history) {
  riskProfile.history = (history || []).map((entry) => entry.questionSet);
}
